import React from "react"
import { RecoilRoot } from "recoil"
import GoTop from "./GoTop"
import SEO from "./SEO"
// import GlobalCTA from "../Common/GlobalCTA"
import StickyWhatsAppButton from "../Common/StickyWhatsAppButton"

const Layout = ({ children }) => {
  return (
    <RecoilRoot>
      {/* Default SEO without canonical to avoid incorrect canonicalization; pages can override by adding their own <SEO /> */}
      <SEO />
      {children}
      {/* <GlobalCTA /> */}
      <StickyWhatsAppButton />
      <GoTop scrollStepInPx="100" delayInMs="10.50" />
    </RecoilRoot>
  )
}

export default Layout
